import {CONTRACTOR_ROLES, IPERMIT_ROLES} from '../constants/roles';

export const isImpersonating = (role, companyId, impersonateUserId)=> {
  if(!role) return false;

  // console.log('role => ', role);
  // console.log('company Id => ', companyId);
  // console.log('impersonate user id => ',impersonateUserId);

  return Object.values(IPERMIT_ROLES).includes(role) && !!companyId && impersonateUserId == undefined;
};

export const isImpersonatingUser = (role, impersonateUserId)=> {
  if(!role) return false;


  return impersonateUserId != undefined;
};

export const isIpermitUser = (role)=> {
  return Object.values(IPERMIT_ROLES).includes(role);
};

export  const isContractor = (role)=> {
  return Object.values(CONTRACTOR_ROLES).includes(role);
};

/**
 * Who may administer partner API credentials.
 *
 * A direct role check rather than a policy through NewPermissionGate, because
 * the backend rule this has to match is itself role-based and deliberately so:
 * routes/api/partnerAdmin.api.ts restricts /api/partners to IPERMIT_ADMIN and
 * SYSTEM_ADMIN, and excludes COMPANY_ADMIN on purpose - a contractor admin must
 * not be able to hand a third party access to job data, even their own.
 *
 * Approximating that with a policy would drift. The page was previously shown
 * to every iPermit user and to any parent-company COMPANY_ADMIN, both of whom
 * got a 403 on every call the page made.
 */
export const PARTNER_ADMIN_ROLES = [
  IPERMIT_ROLES.IPERMIT_ADMIN,
  IPERMIT_ROLES.SYSTEM_ADMIN,
];

export const canAdministerPartners = (role)=> {
  return PARTNER_ADMIN_ROLES.includes(role);
};
